export default {
  setAgentSkillsSessionComposerDetachingEnabledState(state, isEnabled) {
    state.sessionComposerDetachingEnabled = isEnabled !== false;
  },
};
